import fetch from '../req'

//以下为平台管理员接口

export function createAccount (query) {
  return fetch({
    url: '/jurisdiction/user/add',
    method: 'post',
    data: query
  })
}

export function getAccountInfo (id) {
  return fetch({
    url: '/jurisdiction/user/' + id,
    method: 'get'
  })
}

export function getAccountList (query) {
  return fetch({
    url: '/jurisdiction/user',
    method: 'get',
    params: query
  })
}

export function updateAccountInfo (id, query) {
  return fetch({
    url: '/jurisdiction/user/update/' + id,
    method: 'post',
    data: {
      ...query,
      useId: id
    }
  })
}

export function deleteAccountInfo (id) {
  return fetch({
    url: '/jurisdiction/user/del/' + id,
    method: 'post'
  })
}
